import { render } from "./EditParcours.vue?vue&type=template&id=5c74cf36&scoped=true"
import script from "./EditParcours.vue?vue&type=script&lang=js"
export * from "./EditParcours.vue?vue&type=script&lang=js"

import "./EditParcours.vue?vue&type=style&index=0&id=5c74cf36&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c74cf36"]])

export default __exports__